import type { MonthlyRewardTabKey } from '../services/monthlyRewardService'

export const MONTHLY_REWARD_TAB_ORDER: MonthlyRewardTabKey[] = ['cashback', 'loss', 'refer', 'rank']

export const DEFAULT_MONTHLY_REWARD_TAB_LABELS: Record<MonthlyRewardTabKey, string> = {
  cashback: 'รางวัลยอดเงินคืนสูงสุด',
  loss: 'รางวัลยอดเสียสูงสุด',
  refer: 'สุดยอดนักแนะนำเพื่อน',
  rank: 'สุดยอดนักเล่น(Rank)',
}

export interface MonthlyRewardTabConfig {
  enabled?: boolean
  title?: string
}

export function isMonthlyRewardTabEnabled(
  tabs: Partial<Record<MonthlyRewardTabKey, MonthlyRewardTabConfig>> | undefined,
  tab: MonthlyRewardTabKey
): boolean {
  return tabs?.[tab]?.enabled !== false
}

export function getEnabledMonthlyRewardTabs(
  tabs: Partial<Record<MonthlyRewardTabKey, MonthlyRewardTabConfig>> | undefined
): Array<{ key: MonthlyRewardTabKey; to: MonthlyRewardTabKey; label: string }> {
  return MONTHLY_REWARD_TAB_ORDER
    .filter((key) => isMonthlyRewardTabEnabled(tabs, key))
    .map((key) => ({
      key,
      to: key,
      label: tabs?.[key]?.title?.trim() || DEFAULT_MONTHLY_REWARD_TAB_LABELS[key],
    }))
}

export function isMonthlyRewardConfigUpdate(detail: {
  type?: string
  promotionType?: string
  contentType?: string
  content?: {
    type?: string
    promotionType?: string
  }
} | undefined): boolean {
  if (!detail) return false
  return (
    detail.type === 'monthly_reward_config_updated' ||
    detail.promotionType === 'monthly_reward' ||
    detail.content?.type === 'monthly_reward_config_updated' ||
    detail.content?.promotionType === 'monthly_reward' ||
    (detail.contentType === 'promotion_config' && (
      detail.promotionType === 'monthly_reward' ||
      detail.content?.promotionType === 'monthly_reward'
    ))
  )
}
